export const buttonValues = new Map([
  ['initial', 'Send'],
  ['loading', 'Loading...'],
  ['send', 'Resend'],
])
